/* @flow */

import * as React from 'react';

import {Body} from 'shells/typography';

export const IMAGE_CAROUSEL_SLIDES = [
    {
        key: 'pipelines',
        subtitle: (
            <Body>
                <strong>Smart pipelines</strong>&nbsp;to automate your sales process
            </Body>
        ),
        image: '/include/images/auth/signup-smart-pipelines.png',
    },
    {
        key: 'email-marketing',
        subtitle: (
            <Body>
                <strong>Seamless email marketing</strong>&nbsp;with drip sequences
            </Body>
        ),
        image: '/include/images/auth/signup-email-marketing.png',
    },
    {
        key: 'email-calendar-sync',
        subtitle: (
            <Body>
                <strong>Email and calendar sync</strong>&nbsp;with Google and Microsoft to ensure
                nothing falls through the cracks
            </Body>
        ),
        image: '/include/images/auth/signup-email-calendar-sync.png',
    },
    {
        key: 'chat-and-forms',
        subtitle: (
            <Body>
                <strong>Web chat and forms</strong>&nbsp;to help collect leads from your website
                with no integrations or APIs needed
            </Body>
        ),
        image: '/include/images/auth/signup-chat-and-forms.png',
    },
];
